// extracted by mini-css-extract-plugin
module.exports = {"w1r6s5kh":"w1r6s5kh","ikg2ehu":"ikg2ehu","v":"v","b1gqhq3c":"b1gqhq3c"};